import React from 'react';
import {EBirdMyDataSchema} from "ebird-mydata-reader";
import {EBirdTaxonomyEntry} from "../helpers/useEBirdTaxonomy";
import {useObservationImages} from "../helpers/useObservationImages";
import BigYear from "./big-year";
import type {SpeciesFamilyLink} from "../App";

export type BigYearExplorerProps = {
    observations: EBirdMyDataSchema[],
    speciesImages: any,
    year: string | number | undefined,
    familyByTaxonomicOrder: Map<number, SpeciesFamilyLink>,
    lookupByTaxonomicOrder: (taxonomicOrder: number) => EBirdTaxonomyEntry|undefined
}

export default function BigYearExplorer({
    observations,
    speciesImages,
    year,
    familyByTaxonomicOrder,
    lookupByTaxonomicOrder
}: BigYearExplorerProps) {
    const { setObservationImages } = useObservationImages(speciesImages, lookupByTaxonomicOrder);

    return (
        <BigYear
            observations={observations}
            setObservationImages={setObservationImages}
            year={year}
            familyByTaxonomicOrder={familyByTaxonomicOrder}
        />
    );
}
